import React from "react";

import { FontAwesomeIcon }
from "@fortawesome/react-fontawesome";

import
{
    faFileLines,
    faFilePdf
}
from "@fortawesome/free-solid-svg-icons";

import { OMNISCAN_BLUE }
from "../../../constants/colors";

export default function FolderForagerDocumentsPanel(
{
    documents = [],
    left = 400,
	openFile
})
{
	
	
    return (

        <div
            style={{

                position: "fixed",

                top: "150px",

                left: left,

                right: "40px",

                bottom: "24px",

                display: "flex",
                flexDirection: "column",

                background: "rgba(255,255,255,.20)",

                backdropFilter: "blur(18px)",
                WebkitBackdropFilter: "blur(18px)",

                border: "1px solid rgba(255,255,255,.28)",

                borderRadius: "20px",

                boxShadow:
                    "0 10px 28px rgba(0,0,0,.14)",

                overflow: "hidden",

                transition:
                    "left .35s ease"

            }}
        >

            {/* Header */}

            <div
                style={{

                    display: "flex",

                    alignItems: "center",

                    gap: "10px",

                    height: "52px",

                    padding: "0 20px",

                    borderBottom:
                        "1px solid rgba(255,255,255,.18)",

                    fontWeight: 700,

                    fontSize: "16px",

                    color: "#222"

                }}
            >

                <FontAwesomeIcon

                    icon={faFileLines}

                    style={{

                        color: OMNISCAN_BLUE

                    }}

                />

                Documents

            </div>

            {/* Column Headings */}

            <div
                style={{

                    display: "flex",

                    alignItems: "center",

                    height: "38px",

                    padding: "0 18px",

                    borderBottom:
                        "1px solid rgba(255,255,255,.14)",

                    fontSize: "12px",

                    fontWeight: 700,

                    color: "#666",
					marginRight:'30px',
					marginLeft:'30px',
					borderBottom:'1px solid black'

                }}
            >

                

                <div style={{flex:1}}>
                    Name
                </div>

                <div style={{width:"90px"}}>
                    Type
                </div>

                <div style={{width:"90px"}}>
                    Size
                </div>

                <div style={{width:"130px"}}>
                    Modified
                </div>

            </div>

            {/* Documents */}

            <div
                style={{

                    flex:1,

                    overflowY:"auto"

                }}
            >

                {
                    documents.length === 0

                    ?

                    <div
                        style={{

                            display:"flex",

                            justifyContent:"center",

                            alignItems:"center",

                            height:"100%",

                            color:"#777",

                            fontSize:"14px"

                        }}
                    >

                        No documents found.

                    </div>

                    :

                    documents.map((document,index)=>

                        <div

                            key={index}

                            style={{

                                display:"flex",

                                alignItems:"center",

                                height:"38px",

                                padding:"0 18px",

                                cursor:"pointer",

                                borderBottom:
                                    "1px solid rgba(255,255,255,.08)",

                                transition:
                                    "background .18s ease",
									
									background:
									    index % 2 === 1
									        ? "rgba(255,255,255,.28)"
									        : "transparent",
								width:'calc(100% - 80px)',
								marginLeft:'20px',
								marginRight:'20px',
								borderRadius:'10px'

                            }}

							onMouseEnter={e =>
							    e.currentTarget.style.background =
							        "rgba(255,255,255,.78)"
							}

							onMouseLeave={e =>
							    e.currentTarget.style.background =
							        index % 2 === 0
							            ? "rgba(255,255,255,.28)"
							            : "transparent"
							}
							
							onClick={() => {openFile(document);}}

                        >

                            <div
                                style={{
                                    width:"24px"
                                }}
                            >

                                <FontAwesomeIcon

                                    icon={faFilePdf}

                                    style={{
                                        color:OMNISCAN_BLUE
                                    }}

                                />

                            </div>

                            <div
                                style={{
                                    flex:1,
									fontSize:'14px'
                                }}
                            >

                                {document.title}

                            </div>

                            <div
                                style={{
                                    width:"90px",
									fontSize:'12px'
                                }}
                            >

                                {document.extension}

                            </div>

                            <div
                                style={{
                                    width:"90px",
									fontSize:'12px'
                                }}
                            >

                                {document.size}

                            </div>

                            <div
                                style={{
                                    width:"130px",
									fontSize:'12px'
                                }}
                            >

                                {document.modified}

                            </div>

                        </div>

                    )

                }

            </div>

        </div>

    );

}